<template>
  <generic-view
    :title="$t('categories')"
    icon="tags"
    :searchable="true"
    :configurable="true"
    :show_plus="false"
    :show_refresh="true"
    @refresh="init"
    @configure="configure"
    ref="generic_container"
  >
    <div
      class="ui massive basic blue label"
      v-for="(category, cidx) in categories"
      :key="cidx"
    >
      {{ category.prd_category.name }}
      <i class="delete icon" @click="unsuscribe(category.uuid)"></i>
    </div>
    <configure-modal ref="configure_modal" />
  </generic-view>
</template>

<script>
import { local_api, enterprise_setup, error_toast, api_host } from "@/utils";
import GenericView from "@/components/GenericContainer";
import moment from "moment";
import ConfigureModal from "./ProductCategoryConfigureModal.vue";

export default {
  name: "ProductCategoryPlugin",
  filters: {
    fromNow(value) {
      return moment(value).fromNow();
    },
  },
  props: {
    module: Object,
    product: Object,
  },
  components: {
    "generic-view": GenericView,
    ConfigureModal,
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      categories: [],
      current_filter: "",
      api_host: api_host,
    };
  },
  methods: {
    // remove(img, index) {
    //   let vm = this;
    //   this.$alertify.confirm(
    //     this.$t("are you sure to remove picture?"),
    //     function () {
    //       local_api(vm, "post", "/product_picture/do-remove", {
    //         u: img.uuid,
    //       })
    //         .then(() => {
    //           vm.files.splice(index, 1);
    //         })
    //         .catch((err) => {
    //           error_toast(err);
    //         });
    //     },
    //   );
    // },
    init() {
      let vm = this;

      local_api(vm, "post", "/product_category/do-get-item-categories", {
        uuid: vm.$props.product.uuid,
      })
        .then((categories) => {
          vm.categories = categories;
        })
        .catch((err) => {
          error_toast(err);
          console.error(err);
        });
    },
    // filter(query) {
    //   this.current_filter = query;
    //   if (query == "") console.log("clear query");
    //   else console.log("do something with query", query);
    // },
    assign_category(category_id) {
      let vm = this;
      local_api(vm, "post", "/product_category/do-suscribe", {
        c: category_id,
        p: vm.product.product_id,
      })
        .then(() => {
          vm.init();
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    unsuscribe(suscription_uuid) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove category for this product?"),
        function () {
          local_api(vm, "post", "/product_category/do-unsuscribe", {
            u: suscription_uuid,
          })
            .then(() => {
              vm.init();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    configure() {
      // console.log("configure category modal");
      let vm = this;
      vm.$refs.configure_modal.show_modal();
    },
  },
  mounted() {
    let vm = this;

    let onSearchResponse = (data) => {
      let rslt = [];
      data.map((r) => {
        rslt.push({
          title: r.name,
          description: r.number,
          category: r,
        });
      });
      rslt.push({
        title: vm.$t("new"),
        description: vm.$t("new category"),
        category: "NEW",
      });
      return { results: rslt };
    };
    let onSearchSelect = (data) => {
      // console.log("category selected", data.category);
      if (data.category == "NEW") {
        vm.$alertify.prompt(
          vm.$t("enter category name"),
          vm.current_filter,
          function (element, value) {
            local_api(vm, "post", "/product_category/do-simple-create", {
              n: value,
            })
              .then((l) => {
                vm.assign_category(l.category_id);
                // console.log("new category created", l);
              })
              .catch((err) => {
                error_toast(err);
              });
          },
        );
      } else {
        vm.assign_category(data.category.category_id);
      }
    };

    setTimeout(function () {
      vm.init();
      vm.$refs.generic_container.init_search_control({
        action: "search product category",
        onSearchResponse: onSearchResponse,
        onSearchSelect: onSearchSelect,
        maxResults: 5,
      });
    }, 100);
  },
  watch: {},
};
</script>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
